import React, { createElement } from "react";
import {
	FileCheck,
	FilePlus,
	FileSliders,
	FileType,
	FileUp,
	FileUser
} from "lucide-react";
import dayjs from "dayjs";

import { ContractSolicitationStatus } from "../../../../../../types/contractSolicitation";

import ls from "Localization";

import { DateText, IconWrapper, Label, Step, StepperContainer } from "./styles";

const STATUS_ORDER = [
	ContractSolicitationStatus.Requested,
	ContractSolicitationStatus.Production,
	ContractSolicitationStatus.Adjustment,
	ContractSolicitationStatus.Validation,
	ContractSolicitationStatus.Creation,
	ContractSolicitationStatus.Finished
];

const STATUS_COLORS = {
	[ContractSolicitationStatus.Requested]: "#00bba7",
	[ContractSolicitationStatus.Production]: "#f0b100",
	[ContractSolicitationStatus.Adjustment]: "#ff6900",
	[ContractSolicitationStatus.Validation]: "#ad46ff",
	[ContractSolicitationStatus.Creation]: "#2b7fff",
	[ContractSolicitationStatus.Finished]: "#497d00"
};

const STATUS_ICONS = {
	[ContractSolicitationStatus.Requested]: FilePlus,
	[ContractSolicitationStatus.Production]: FileType,
	[ContractSolicitationStatus.Adjustment]: FileSliders,
	[ContractSolicitationStatus.Validation]: FileUser,
	[ContractSolicitationStatus.Creation]: FileUp,
	[ContractSolicitationStatus.Finished]: FileCheck
};

const DEFAULT_COLOR = "#ffffff";

const ICON_COLORS = {
	active: "#ffffff",
	inactive: "#71717b"
};

const getStepColor = (stepStatus, currentStatus) => {
	if (stepStatus === ContractSolicitationStatus.Requested) {
		return STATUS_COLORS[stepStatus];
	}

	if (stepStatus === ContractSolicitationStatus.Finished) {
		return currentStatus === ContractSolicitationStatus.Finished
			? STATUS_COLORS[stepStatus]
			: DEFAULT_COLOR;
	}

	const stepIndex = STATUS_ORDER.indexOf(stepStatus);
	const currentIndex = STATUS_ORDER.indexOf(currentStatus);

	return currentIndex > stepIndex - 1
		? STATUS_COLORS[stepStatus]
		: DEFAULT_COLOR;
};

const getIconColor = (stepStatus, currentStatus) => {
	const stepColor = getStepColor(stepStatus, currentStatus);
	return stepColor === DEFAULT_COLOR
		? ICON_COLORS.inactive
		: ICON_COLORS.active;
};

export function Stepper({ steps, currentStatus }) {
	return (
		<StepperContainer>
			{steps.map((step, index) => {
				const color = getStepColor(step.status, currentStatus);
				const iconColor = getIconColor(step.status, currentStatus);

				return (
					<Step
						key={index}
						color={color}
						status={step.status}
						currentStatus={currentStatus}
						nextStatus={
							index < steps.length - 1 ? steps[index + 1].status : null
						}
					>
						<IconWrapper color={color} status={step.status}>
							{createElement(STATUS_ICONS[step.status], {
								color: iconColor,
								size: 20
							})}
						</IconWrapper>
						<Label>{ls[step.status]}</Label>
						<DateText>
							{step.createdAt
								? dayjs(step.createdAt).format("DD/MM/YYYY [às] HH:mm")
								: "Não iniciado"}
						</DateText>
					</Step>
				);
			})}
		</StepperContainer>
	);
}
